<ng-container *ngFor="let template of utilityBarService.templates">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</ng-container>
